module.exports = __webpack_public_path__ + "static/media/scrollup.f391892b.svg";